import ObjectWidget from './ObjectWidget';
import BaseDashboard from '../BaseDashboard';
import Pin from '@/types/FilterTree/Pin';

class ObjectDashboard extends BaseDashboard<ObjectWidget> {
    ObjectType: string;
    ProfileIds: number[];
    Pins: Pin[];
}

export default ObjectDashboard;